import { useState } from 'react';
import { Tabs } from 'antd';

import Loading from 'components/Loading/Loading';
import CollectionsSection from './Collections/CollectionsSection';
import RecoveriesSection from './Recoveries/RecoveriesSection';
import useDefaultOffersTab, { OFFERS_TABS } from './useDefaultOffersTab';

const OffersSection = () => {
  const [activeTab, setActiveTab] = useState(null);
  const { defaultTab, loading } = useDefaultOffersTab();

  if (loading && !activeTab) {
    return <Loading />;
  }

  const items = [
    {
      key: OFFERS_TABS.COLLECTIONS,
      label: 'Collections',
      children: <CollectionsSection />,
    },
    {
      key: OFFERS_TABS.RECOVERIES,
      label: 'Recoveries',
      children: <RecoveriesSection />,
    },
  ];

  return (
    <Tabs
      items={items}
      activeKey={activeTab ?? defaultTab}
      onChange={setActiveTab}
    />
  );
};

export default OffersSection;
